import { genArray } from "SuperAdmin/Utils/ArrayGenerator";
import { Skeleton, Table } from "antd";

const LoadingTable = ({ columns, rows, isLoading, component }) => {
  const loadingTableColumns = columns.map((item) => {
    return {
      ...item,
      render: () => {
        return <Skeleton.Input active={true} />;
      },
    };
  });
  return isLoading ? (
    <Table
      rowKey={(record) => record.id}
      className="table"
      columns={loadingTableColumns}
      dataSource={genArray(rows)}
      pagination={{ position: ["none", "none"] }}
    />
  ) : (
    component
  );
};

export default LoadingTable;
